export default __webpack_public_path__ + "43eea52ee0c6e3f35812810c05422f25.svg";